import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=0b708c61&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=0b708c61&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b708c61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b708c61')) {
      api.createRecord('0b708c61', component.options)
    } else {
      api.reload('0b708c61', component.options)
    }
    module.hot.accept("./GeneralSettings.vue?vue&type=template&id=0b708c61&scoped=true", function () {
      api.rerender('0b708c61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GeneralSettings.vue"
export default component.exports